import React from "react";
import Headers from "../../components/Headers";
import { Layout, Form, Input, Button, message, Modal } from "antd";
import { editPassword } from "../../api/login";
import { Encrypt } from "../../utils/secret";

const BreadCrumbData = [{ path: "/page/useraccount", name: "账户" }];
const formItemLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 16,
  },
};
class UserAccount extends React.Component {
  state = {
    confirmDirty: false,
    visible: false,
    account: JSON.parse(sessionStorage.getItem("loginInfo")).mobilePhone,
    password: "1234567",
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { oldPassword, newPassword } = values;
        let data = Encrypt(
          JSON.stringify({
            oldPassword,
            newPassword,
          })
        );
        editPassword(data).then((res) => {
          if (res.success) {
            message.success("修改成功");
          } else {
            message.error(res.message);
          }
        });
        this.handleCancel();
      }
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("newPassword")) {
      callback("确认密码不一致");
    } else {
      callback();
    }
  };
  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;

    if (value && this.state.confirmDirty) {
      form.validateFields(["confirmNewPassword"], { force: true });
    }
    callback();
  };
  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };
  render() {
    const { account, password, visible } = this.state;
    const { getFieldDecorator } = this.props.form;
    let StrLength = password.length;
    let str = "";
    for (let i = 0; i < StrLength; i++) {
      str = str + "*";
    }

    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="searchTitle">
          <span>账号设置</span>
          <div className="lineBetween"></div>
          <Form {...formItemLayout} onSubmit={this.handleSubmit}>
            <Form.Item label="登陆账号">
              <span>{account}</span>
            </Form.Item>
            <Form.Item label="登陆密码">
              <span>{str}</span>
              <span
                style={{ color: "#1890FF", marginLeft: 20, cursor: "pointer" }}
                onClick={() => this.setState({ visible: true })}
              >
                修改
              </span>
            </Form.Item>
            <Modal
              destroyOnClose
              title="修改密码"
              visible={visible}
              onOk={this.handleSubmit}
              onCancel={this.handleCancel}
            >
              <Form.Item label="原密码">
                {getFieldDecorator("oldPassword", {
                  rules: [{ required: true, message: "请输入原密码" }],
                })(<Input type="password" placeholder="请输入原密码" />)}
              </Form.Item>
              <Form.Item label="新密码">
                {getFieldDecorator("newPassword", {
                  rules: [
                    { required: true, message: "请输入新密码" },
                    {
                      validator: this.validateToNextPassword,
                    },
                  ],
                })(<Input type="password" placeholder="请输入新密码" />)}
              </Form.Item>
              <Form.Item label="新密码">
                {getFieldDecorator("confirmNewPassword", {
                  rules: [
                    { required: true, message: "请再次输入新密码" },
                    {
                      validator: this.compareToFirstPassword,
                    },
                  ],
                })(
                  <Input
                    type="password"
                    placeholder="请再次输入新密码"
                    onBlur={this.handleConfirmBlur}
                  />
                )}
              </Form.Item>
            </Modal>
          </Form>
        </div>
      </div>
    );
  }
}
export default Form.create()(UserAccount);
